import HowItsMade, { HowItsMadeProps } from "./HowItsMade";

export { HowItsMade, HowItsMadeProps };

export default HowItsMade;
